export { default } from './MembershipLabel';
